"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _CircularLoader = _interopRequireDefault(require("../../../components/CircularLoader"));

var _default = function _default(_ref) {
  var className = _ref.className,
      header = _ref.header,
      subtitle = _ref.subtitle,
      children = _ref.children,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? true : _ref$margin,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('bg-app', {
      'md:mt-4': margin
    })
  }, !(0, _isNil["default"])(header) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-8 py-4 border-b-2"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "font-bold text-xl"
  }, header), !(0, _isNil["default"])(subtitle) && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-3 text-sm"
  }, subtitle)), isLoading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-6"
  }, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], null)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('p-8 max-w-screen-md container', className)
  }, children));
};

exports["default"] = _default;
//# sourceMappingURL=Layout.js.map